import toDisplayDate from './toDisplayDate';

// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
//
// Inbox #223. A chart inside a periodised report showed the generic empty state
// — "Nog geen gegevens · Gegevens verschijnen zodra ze beschikbaar zijn" —
// while 24 answers existed; they simply fell outside the report's own window.
// The reader was told to wait for data that was already there, and the window
// itself appeared nowhere on screen.
//
// This copy makes no claim about whether data exists: it states the window and
// says the reader may be looking at the wrong one. True in both cases, and it
// points at the one thing the reader can actually act on.

/**
 * Empty-state copy for a chart whose period yielded nothing.
 *
 * @param {*} start - Period lower bound (Date, Firestore Timestamp, or nothing)
 * @param {*} end - Period upper bound
 * @returns {{headline: string, subtext: string}|null} `null` when no period is
 *   active, or when neither bound could be read — better the generic copy than
 *   a sentence with a broken date in it.
 */
const periodEmptyState = (start, end) => {
    if (!start && !end) return null;

    const van = toDisplayDate(start);
    const tot = toDisplayDate(end);
    if (!van && !tot) return null;

    let subtext;
    if (van && tot) {
        subtext = `Deze weergave toont ${van} tot en met ${tot}. Buiten die periode kunnen er wel gegevens zijn.`;
    } else if (van) {
        subtext = `Deze weergave toont alles vanaf ${van}. Buiten die periode kunnen er wel gegevens zijn.`;
    } else {
        subtext = `Deze weergave toont alles tot en met ${tot}. Buiten die periode kunnen er wel gegevens zijn.`;
    }

    return { headline: 'Geen gegevens in deze periode', subtext };
};

export default periodEmptyState;
